/* unplugin-vue-components disabled */import script from "./QaPicker.vue?vue&type=script&lang=tsx&setup=true"
export * from "./QaPicker.vue?vue&type=script&lang=tsx&setup=true"

import "./QaPicker.vue?vue&type=style&index=0&id=6f2ccb50&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f2ccb50"]])

export default __exports__